var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterDeposits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#738b95",
    d: "M131.297 297.535h43.895v189.158h-43.895z",
    opacity: 1,
    "data-original": "#738b95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#617881",
    d: "M131.297 297.535h15.962v189.158h-15.962z",
    opacity: 1,
    "data-original": "#617881"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#738b95",
    d: "M336.808 297.535h43.895v189.158h-43.895z",
    opacity: 1,
    "data-original": "#738b95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#617881",
    d: "M336.808 297.535h15.962v189.158h-15.962z",
    opacity: 1,
    "data-original": "#617881"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcdf95",
    d: "M481.388 458.277H30.612c-12.764 0-23.112 10.347-23.112 23.112 0 12.764 10.347 23.112 23.112 23.112h450.777c12.764 0 23.112-10.347 23.112-23.112-.001-12.765-10.348-23.112-23.113-23.112z",
    opacity: 1,
    "data-original": "#bcdf95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c8a5",
    d: "M103.39 497.728c4.18 4.18 9.96 6.77 16.34 6.77H30.61c-6.38 0-12.16-2.59-16.34-6.77s-6.77-9.96-6.77-16.34c0-12.77 10.35-23.11 23.11-23.11h89.12c-12.76 0-23.11 10.34-23.11 23.11 0 6.38 2.59 12.16 6.77 16.34z",
    opacity: 1,
    "data-original": "#93c8a5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9bb9c1",
    d: "M422.44 274.075H89.561c-14.325 0-25.938 11.613-25.938 25.938s11.613 25.938 25.938 25.938H422.44c14.325 0 25.938-11.613 25.938-25.938s-11.613-25.938-25.938-25.938z",
    opacity: 1,
    "data-original": "#9bb9c1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86a0af",
    d: "M161.522 318.354a25.83 25.83 0 0 0 18.34 7.6h-90.3c-7.16 0-13.65-2.9-18.34-7.6-4.69-4.69-7.6-11.17-7.6-18.34 0-14.32 11.62-25.93 25.94-25.93h90.3c-14.32 0-25.94 11.61-25.94 25.93 0 7.17 2.91 13.65 7.6 18.34z",
    opacity: 1,
    "data-original": "#86a0af"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b1e4f9",
    d: "M415.106 53.382 256 7.5 96.895 53.382v220.693h318.211z",
    opacity: 1,
    "data-original": "#b1e4f9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93d8e4",
    d: "m256.005 7.503-75.65 45.879v220.701h-83.46V53.382z",
    opacity: 1,
    "data-original": "#93d8e4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 157.016,
    r: 76.025,
    fill: "#ffece7",
    opacity: 1,
    "data-original": "#ffece7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b1e4f9",
    d: "M230.901 173.37c0 .83.012 1.656.037 2.48.947 31.983 49.178 31.983 50.126 0a85.19 85.19 0 0 0 .037-2.48c0-23.231-9.631-44.201-25.099-59.176-15.471 14.975-25.101 35.945-25.101 59.176z",
    opacity: 1,
    "data-original": "#b1e4f9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.389 450.777h-93.186V333.45h34.237c18.438 0 33.439-15.001 33.439-33.44 0-8.937-3.481-17.332-9.796-23.633-6.278-6.277-14.609-9.749-23.474-9.793V210.82h1.58c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-1.58v-70.33h1.58c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-1.58V53.38a7.502 7.502 0 0 0-5.422-7.207l-105.11-30.31a7.5 7.5 0 0 0-4.156 14.413l54.119 15.606H149.96L256 15.305l23.252 6.701a7.5 7.5 0 0 0 4.154-14.413l-25.33-7.3a7.487 7.487 0 0 0-4.155 0l-159.11 45.88a7.5 7.5 0 0 0-5.422 7.207v57.11h-1.58a7.5 7.5 0 0 0 0 15h1.58v70.33h-1.58a7.5 7.5 0 0 0 0 15h1.58v55.765c-18.361.092-33.27 15.049-33.27 33.425 0 8.943 3.481 17.342 9.797 23.644a33.45 33.45 0 0 0 5.134 4.205 7.501 7.501 0 0 0 8.298-12.496 18.41 18.41 0 0 1-2.832-2.321c-3.48-3.473-5.397-8.101-5.397-13.031 0-10.162 8.272-18.43 18.44-18.43h332.88c4.922 0 9.552 1.919 13.042 5.409a18.271 18.271 0 0 1 5.397 13.021c0 10.168-8.271 18.44-18.439 18.44H104.56a7.5 7.5 0 0 0 0 15h19.237v117.326H30.612C13.733 450.777 0 464.509 0 481.388S13.733 512 30.612 512h450.777C498.268 512 512 498.268 512 481.388s-13.732-30.611-30.611-30.611zM407.61 195.82h-77.681a82.992 82.992 0 0 0 9.595-38.805 83.033 83.033 0 0 0-6.197-31.525h74.282v70.33zm-220.135-38.805c0-37.785 30.74-68.525 68.525-68.525 37.784 0 68.524 30.74 68.524 68.525S293.784 225.54 256 225.54c-37.785 0-68.525-30.74-68.525-68.525zM104.39 60.883h303.22v49.608h-82.279c-15.013-22.3-40.486-37-69.332-37s-54.319 14.7-69.332 37H104.39zm0 64.607h74.282a83.052 83.052 0 0 0-6.197 31.525 82.983 82.983 0 0 0 9.596 38.805H104.39zm0 141.09v-55.76h87.793c15.334 18.158 38.245 29.72 63.816 29.72s48.483-11.562 63.816-29.72h87.794v55.76zm78.303 184.197v-10.56L256 401.602l73.308 38.615v10.56zm0-87.79 57.215 30.138-57.215 30.138zm146.615 60.276-57.215-30.138 57.215-30.138zm43.895 27.514h-28.896V333.452h28.896zM329.308 333.45v12.583L256 384.648l-73.308-38.615V333.45zm-190.511.002h28.896v117.325h-28.896zM481.389 497H30.612C22.004 497 15 489.997 15 481.388s7.003-15.612 15.612-15.612h450.777c8.608 0 15.611 7.003 15.611 15.612S489.997 497 481.389 497z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 207.337c15.72 0 31.951-10.739 32.56-31.265.026-.897.04-1.798.04-2.702 0-24.54-9.725-47.47-27.383-64.565a7.5 7.5 0 0 0-10.434 0C233.125 125.9 223.4 148.83 223.4 173.37c0 .904.013 1.805.04 2.702.608 20.526 16.84 31.265 32.56 31.265zm0-82.178c11.4 13.476 17.6 30.331 17.6 48.211 0 .755-.012 1.508-.034 2.258-.342 11.543-9.068 16.709-17.565 16.709-8.498 0-17.225-5.167-17.566-16.709a76.973 76.973 0 0 1-.033-2.258c-.001-17.88 6.198-34.735 17.598-48.211z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDeposits);
export default __webpack_public_path__ + "static/media/waterDeposits.d5784872ec5e7b52957c4c973fb750fc.svg";
export { ForwardRef as ReactComponent };